import { Spinner } from 'components/ui/general';
import { SelectSelectors } from 'consts/cypress';

import { reactSelectComponents } from '../reactSelectComponents';

import styles from '../Select.module.scss';

export const LoadingIndicator = (props: any) => {
  return (
    <div
      className={styles.loadingIndicator}
      data-cy={SelectSelectors.LoadingIndicator}
    >
      <reactSelectComponents.LoadingIndicator {...props} />
      <Spinner visible size="sm" />
    </div>
  );
};
